export enum DimensionUnit {
  MILLIMETERS = 'mm',
  CENTIMETERS = 'cm',
  INCHES = 'in',
}
